import { GoogleAnalytics, GoogleTagManager, sendGTMEvent } from '@next/third-parties/google';
// import * as segment from '@segment/snippet';
import { SessionProvider, useSession } from 'next-auth/react';
import { PostHogProvider } from 'posthog-js/react';
import { FacebookPixelProvider } from '../contexts/FacebookPixelContext';
import '../styles/globals.css';
import AntdThemeProvider from '../components/providers/AntdThemeProvider';
import posthog from '../utils/posthog';

// router loading
import { SG_EVENT_NAMES } from '@/utils/tools/segment/eventNames';
// import { trackPageViewed } from '@/utils/tools/segment/tracking';
import { useCurrentUser } from '@/hooks/data/user';
import { identifyUser } from '@/utils/tools/segment/tracking';
import { useRouter } from 'next/router';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import { useEffect } from 'react';
import { SWRConfig } from 'swr';

function GlobalUserIdentifier() {
   const { data: session } = useSession();
   const { user } = useCurrentUser();
   useEffect(() => {
      if (user && session?.user) {
         identifyUser(user.id || user.email, {
            email: user.email,
            name: user.name,
            username: session.user.username,
            image: user.avatar,
            isPremium: user.isPremium,
            onboardingBringOption: user.bringOptionsId?.option || null,
            onboardingRoleOption: user.roleOptionsId?.option || null,
            onboardingNewsLetterSubscription: user.newsLetterSubscription,
         });
      }
   }, [user, session]);
   return null;
}

export default function App({ Component, pageProps }) {
   const router = useRouter();
   const getLayout = Component.getLayout || ((page) => page);

   NProgress.configure({ showSpinner: false });

   useEffect(() => {
      const handler = (url, param) => {
         if (param?.shallow) {
            // trackPageViewed(url);
            sendGTMEvent({ event: SG_EVENT_NAMES.PAGE_VIEWED, value: url });
            // Track page views in PostHog
            posthog.capture('$pageview');
         }
         if (!param?.shallow) NProgress.start();
      };
      router.events.on('routeChangeStart', handler);
      return () => router.events.off('routeChangeStart', handler);
   }, [router.events]);

   useEffect(() => {
      const handler = (url) => {
         NProgress.done();
         // trackPageViewed(url);
         sendGTMEvent({ event: SG_EVENT_NAMES.PAGE_VIEWED, value: url });
         // Track page views in PostHog
         posthog.capture('$pageview');
      };

      router.events.on('routeChangeComplete', handler);
      return () => router.events.off('routeChangeComplete', handler);
   }, [router.events]);

   return (
      <>
         <FacebookPixelProvider pixelId="1309056782583515">
            <PostHogProvider client={posthog}>
               <SWRConfig
                  value={{
                     fetcher: (resource, init) =>
                        fetch(resource, init).then((res) => {
                           if (!res.ok) {
                              const error = new Error('An error occurred while fetching the data.');
                              // get error message from body or default to response status
                              error.info = res.json();
                              error.status = res.status;
                              throw error;
                           }
                           return res.json();
                        }),
                     // refreshInterval: 5000,
                  }}
               >
                  <SessionProvider>
                     <GlobalUserIdentifier />
                     <AntdThemeProvider>{getLayout(<Component {...pageProps} />)}</AntdThemeProvider>
                  </SessionProvider>
               </SWRConfig>
            </PostHogProvider>
         </FacebookPixelProvider>
         <GoogleTagManager gtmId={'GTM-PXV5KZZ'} />
         <GoogleAnalytics gaId="G-6TJZ0TBTMG" />
      </>
   );
}
